import { createAsyncTypes } from 'utils/ActionCreator'

export const SHARE_SUBMIT_ASYNC = createAsyncTypes('SHARE_SUBMIT', 'Share')
export const FETCH_SHARING_EMAILS_ASYNC = createAsyncTypes('FETCH_SHARING_EMAILS_ASYNC', 'Share')
export const SET_SHARING_EMAILS_PAGE = 'Share/SET_SHARING_EMAILS_PAGE'

export const SHARE_RESET = 'Share/SHARE_RESET'
export const SHARE_RESET_ERROR = 'Share/SHARE_RESET_ERROR'
export const SHARE_EMAILS_CHANGE = 'Share/SHARE_EMAILS_CHANGE'
export const SHARE_MESSAGE_CHANGE = 'Share/SHARE_MESSAGE_CHANGE'

export const SHARE_TYPE = {
  REPORT: {
    AWARENESS: 'report_awareness',
    PHISHING_SIMULATOR: 'report_phishingSimulator',
    MITIGATION: 'report_mitigation',
    THREAT_PROTECTION: 'report_threatProtection',
    SCANBACK: 'report_scanback',
    REPORTED_INCIDENTS: 'report_reportedIncidents',
    ANOMALIES: 'report_anomaliesList',
    INCIDENT_SUMMARY_INCIDENTS: 'report_incidentSummaryIncidents',
    REMEDIATED_EMAILS: 'report_remediatedEmails',
    REPORT_MAILBOXES: 'report_mailboxes',
    THREAT_LOG_REPORT: 'report_threat_log',
    INVESTIGATION_REPORT: 'report_investigation',
    POC_REPORT_LAST_LOG: 'report_poc_last_log',
  },
  TEST: {
    CAMPAIGN: 'test_campaign',
  },
}
